/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ReceivedAccessRequestsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ServiceAdminOrgAccessRequestFilter>;
}>;


export type ReceivedAccessRequestsQuery = { __typename: 'Query', organizationAccessRequests: Array<{ __typename: 'ServiceAdminOrgAccessRequestDocument', id: string, requestedDurationMinutes: number, status: Types.ServiceAdminOrgAccessRequestStatus, createdAt: any, accessExpiresAt?: any | null, requestingServiceAdmin?: { __typename: 'ServiceAdminOrgAccessRequestUser', givenName?: string | null, familyName?: string | null, email: string } | null }> };

export type DecideOrgAdminAccessRequestMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  decision: Types.ServiceAdminOrgAccessRequestDecision;
}>;


export type DecideOrgAdminAccessRequestMutation = { __typename: 'Mutation', decideOrgAdminAccessRequest: { __typename: 'ServiceAdminOrgAccessRequestDocument', id: string, status: Types.ServiceAdminOrgAccessRequestStatus, accessExpiresAt?: any | null, decidedAt?: any | null } };

export type RevokeOrgAdminAccessRequestMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type RevokeOrgAdminAccessRequestMutation = { __typename: 'Mutation', revokeOrgAdminAccessRequest: { __typename: 'ServiceAdminOrgAccessRequestDocument', id: string, status: Types.ServiceAdminOrgAccessRequestStatus } };


export const ReceivedAccessRequestsDocument = gql`
    query ReceivedAccessRequests($filter: ServiceAdminOrgAccessRequestFilter) {
  organizationAccessRequests(filter: $filter) {
    id
    requestingServiceAdmin {
      givenName
      familyName
      email
    }
    requestedDurationMinutes
    status
    createdAt
    accessExpiresAt
  }
}
    `;

/**
 * __useReceivedAccessRequestsQuery__
 *
 * To run a query within a React component, call `useReceivedAccessRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceivedAccessRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceivedAccessRequestsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReceivedAccessRequestsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReceivedAccessRequestsQuery, ReceivedAccessRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReceivedAccessRequestsQuery, ReceivedAccessRequestsQueryVariables>(ReceivedAccessRequestsDocument, options);
      }
export function useReceivedAccessRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReceivedAccessRequestsQuery, ReceivedAccessRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReceivedAccessRequestsQuery, ReceivedAccessRequestsQueryVariables>(ReceivedAccessRequestsDocument, options);
        }
export type ReceivedAccessRequestsQueryHookResult = ReturnType<typeof useReceivedAccessRequestsQuery>;
export type ReceivedAccessRequestsLazyQueryHookResult = ReturnType<typeof useReceivedAccessRequestsLazyQuery>;
export type ReceivedAccessRequestsQueryResult = ApolloReactCommon.QueryResult<ReceivedAccessRequestsQuery, ReceivedAccessRequestsQueryVariables>;
export const DecideOrgAdminAccessRequestDocument = gql`
    mutation DecideOrgAdminAccessRequest($id: ID!, $decision: ServiceAdminOrgAccessRequestDecision!) {
  decideOrgAdminAccessRequest(id: $id, decision: $decision) {
    id
    status
    accessExpiresAt
    decidedAt
  }
}
    `;
export type DecideOrgAdminAccessRequestMutationFn = ApolloReactCommon.MutationFunction<DecideOrgAdminAccessRequestMutation, DecideOrgAdminAccessRequestMutationVariables>;

/**
 * __useDecideOrgAdminAccessRequestMutation__
 *
 * To run a mutation, you first call `useDecideOrgAdminAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecideOrgAdminAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decideOrgAdminAccessRequestMutation, { data, loading, error }] = useDecideOrgAdminAccessRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      decision: // value for 'decision'
 *   },
 * });
 */
export function useDecideOrgAdminAccessRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DecideOrgAdminAccessRequestMutation, DecideOrgAdminAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DecideOrgAdminAccessRequestMutation, DecideOrgAdminAccessRequestMutationVariables>(DecideOrgAdminAccessRequestDocument, options);
      }
export type DecideOrgAdminAccessRequestMutationHookResult = ReturnType<typeof useDecideOrgAdminAccessRequestMutation>;
export type DecideOrgAdminAccessRequestMutationResult = ApolloReactCommon.MutationResult<DecideOrgAdminAccessRequestMutation>;
export type DecideOrgAdminAccessRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<DecideOrgAdminAccessRequestMutation, DecideOrgAdminAccessRequestMutationVariables>;
export const RevokeOrgAdminAccessRequestDocument = gql`
    mutation RevokeOrgAdminAccessRequest($id: ID!) {
  revokeOrgAdminAccessRequest(id: $id) {
    id
    status
  }
}
    `;
export type RevokeOrgAdminAccessRequestMutationFn = ApolloReactCommon.MutationFunction<RevokeOrgAdminAccessRequestMutation, RevokeOrgAdminAccessRequestMutationVariables>;

/**
 * __useRevokeOrgAdminAccessRequestMutation__
 *
 * To run a mutation, you first call `useRevokeOrgAdminAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOrgAdminAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOrgAdminAccessRequestMutation, { data, loading, error }] = useRevokeOrgAdminAccessRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeOrgAdminAccessRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevokeOrgAdminAccessRequestMutation, RevokeOrgAdminAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokeOrgAdminAccessRequestMutation, RevokeOrgAdminAccessRequestMutationVariables>(RevokeOrgAdminAccessRequestDocument, options);
      }
export type RevokeOrgAdminAccessRequestMutationHookResult = ReturnType<typeof useRevokeOrgAdminAccessRequestMutation>;
export type RevokeOrgAdminAccessRequestMutationResult = ApolloReactCommon.MutationResult<RevokeOrgAdminAccessRequestMutation>;
export type RevokeOrgAdminAccessRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<RevokeOrgAdminAccessRequestMutation, RevokeOrgAdminAccessRequestMutationVariables>;